import React, { useEffect, useState } from 'react';
import { Box, IconButton } from '@mui/material';
import { Autocomplete } from 'src/components/common/Autocomplete';
import { Link } from '@mui/icons-material';

import { useDebounce } from 'src/hooks/useDebounce';
import { useGetUsers } from 'src/services/apiService';
import { routesMap } from 'src/routes';

//shared
import { User as IUser } from 'src/shared/api';

interface Props {
  user?: IUser | null;
  onChange?: (user: IUser | null) => any;
}

export const UserSelect: React.FunctionComponent<Props> = ({
  onChange,
  user,
}) => {
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    setOpen(!user);
  }, [user]);

  const [searchTerm, setTerm] = useState('');

  const debouncedTerm = useDebounce<string>(searchTerm, 700);

  const { data, isLoading } = useGetUsers({
    query: debouncedTerm,
    skip: !debouncedTerm || debouncedTerm.length < 3,
  });

  return (
    <Box display="flex">
      <Autocomplete
        fullWidth
        value={user}
        onChange={(e, value: IUser) => onChange && onChange(value)}
        options={data?.data || (user ? [user] : [])}
        getOptionLabel={(option: IUser) =>
          [
            option?.lastName,
            option?.firstName,
            option?.fatherName,
            option?.phoneNumber,
            option?.email,
          ]
            ?.filter(item => item)
            ?.join(' ')
        }
        onChangeTextField={e => setTerm(e.target.value)}
        label={'Пользователь'}
        loading={isLoading}
        actions={
          user?.id
            ? [
                <IconButton
                  size="small"
                  target="_blank"
                  href={routesMap.user.getRoute(user?.id)}
                  title="Открыть пользователя"
                  onClick={e => e.stopPropagation()}
                >
                  <Link />
                </IconButton>,
              ]
            : []
        }
      />
    </Box>
  );
};
